null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/scala/scala-collection-compat/7d1f7aa7e876b8f43a2f9ba5e882b80369f4b10d/compat/src/main/scala-2.12/scala/collection/compat/package.scala